/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dropdown } from 'react-bootstrap';
import { customerService } from '../../services/customer.service';
import LogicContext from '../../Context/LogicContext';
import { useEffect, useRef, useState } from 'react';
import { useContext } from 'react';
import { GetRecoilApprovedList, SetRecoilApprovedList } from '../../store/customerApprovedAtom';
import CustomerContext from '../../Context/CustomerContext';
import { IoMdRefresh } from 'react-icons/io';
import { IoCloudDownloadOutline, IoSearch, IoClose } from 'react-icons/io5';
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useNavigate } from 'react-router-dom';
import { corporateService } from '../../services/corporation.service';
import ApproveFilterSelect from './AppproveFilterSelect';
import CopFilterList from './CopTypefilter';
import GeneralCustomTable from '../../helpers/GeneralCustomTable';
import { formatCustomDate, formatCustomDateWithoutTime } from '../../helpers/formatCustomDate';
import Papa from 'papaparse'; // ← Added for reliable CSV export
import moment from 'moment';

const columns = [
  {
    title: 'Id',
    dataIndex: 'Customer_Id',
    className: 'text-primary',
    sorter: (a, b) => (a?.Customer_Id ?? '') - (b?.Customer_Id ?? ''),
  },
  {
    title: 'Customer Name',
    key: 'Customer_Full_Name',
    dataIndex: 'Customer_Full_Name',
    className: 'text-primary',
    sorter: (a, b) => (a?.Customer_Full_Name ?? '').localeCompare(b?.Customer_Full_Name ?? ''),
  },
  {
    title: 'Corporate Name',
    dataIndex: 'Customer_Email_Address',
    sorter: (a, b) => (a?.Customer_Email_Address ?? '').localeCompare(b?.Customer_Email_Address ?? ''),
  },
  {
    title: 'Mobile',
    dataIndex: 'Customer_Mobile_No',
    sorter: (a, b) => (a?.Customer_Mobile_No ?? '').localeCompare(b?.Customer_Mobile_No ?? ''),
  },
  {
    title: 'Corporate Code',
    dataIndex: 'Corporate_Short_Code',
    className: 'text-primary font-bold',
    sorter: (a, b) => (a?.Corporate_Short_Code ?? '').localeCompare(b?.Corporate_Short_Code ?? ''),
  },
  {
    title: 'Status',
    dataIndex: 'Customer_Approve_Status_Name',
    sorter: (a, b) => (a?.Customer_Approve_Status_Name ?? '').localeCompare(b?.Customer_Approve_Status_Name ?? ''),
    render: record => (
      <span className={`${record === 'Approved' ? 'font-bold text-green-500' : record === 'Resend' ? 'font-bold text-yellow-500' : ''}`}>
        {record}
      </span>
    ),
  },
  // {
  //   title: 'Registration Date',
  //   dataIndex: 'Registration_Date',
  //   sorter: (a, b) => (a?.Registration_Date ?? '').localeCompare(b?.Registration_Date ?? ''),
  //   render: (record) => <span>{formatCustomDateWithoutTime(record)}</span>,
  // },
];

function CustomerApprovalPage() {
  const logicContext = useContext(LogicContext);
  const getRecoilList = GetRecoilApprovedList();
  const setRecoilList = SetRecoilApprovedList();

  const [tableList, setTableList] = useState([]);
  const [searchText, setSearchText] = useState('');

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const url = pathname.split('/');
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const new_list = queryParams.get('new_list');

  useEffect(() => {
    if (getRecoilList.customer_info?.length) {
      setTableList(getRecoilList.customer_info);
      if (new_list) {
        onStatusFilterSelect({ Status_Id: 2, Status_Name: 'Pending', label: 'Pending' });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getRecoilList]);

  function getApprovedList() {
    corporateService.getCustomerApprovedList().then(response => {
      if (response?.data?.customer_info) {
        setRecoilList(response?.data);
        setTableList(response?.data?.customer_info);
      }
    });
  }

  function onStatusFilterSelect(filter) {
    const option = filter.Status_Id;
    if (option == '0' || !option) {
      setTableList(getRecoilList.customer_info || []);
    } else {
      const newList = getRecoilList.customer_info.filter(cust => cust.Customer_Approve_Status_Id === option);
      setTableList(newList);
    }
  }

  function onCopFilterSelect(filter) {
    const option = filter.Corporate_Name;
    if (option === 'ALL' || !option) {
      setTableList(getRecoilList.customer_info || []);
    } else {
      const newList = getRecoilList.customer_info.filter(cust => cust.Corporate_Name === option);
      setTableList(newList);
    }
  }

  const onClearInput = () => {
    setSearchText('');
    setTableList(getRecoilList.customer_info || []);
  };

  const handleSearch = text => {
    setSearchText(text);
    if (text.trim() === '') {
      setTableList(getRecoilList.customer_info || []);
      return;
    }

    const searchTerm = text.toLowerCase();
    const filtered = (getRecoilList.customer_info || []).filter(item =>
      Object.values(item).some(value => value?.toString().toLowerCase().includes(searchTerm))
    );
    setTableList(filtered);
  };

  function handleRowClick(customer) {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${customer?.Customer_Id}`);
  }

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: tableList.length,
  };

  // ====================== EXPORT CSV ======================
  const exportToCSV = () => {
    if (!tableList?.length) {
      logicContext.showToast('No data to export', 'warning');
      return;
    }

    const headers = columns.map(col => col.title);
    const keys = columns.map(col => col.dataIndex);

    const dataForExport = tableList.map(row => {
      const obj = {};
      keys.forEach((key, i) => {
        let value = row[key] ?? '';

        // Apply same formatting as the table
        if (key === 'Registration_Date') {
          value = formatCustomDate(value);
        }

        obj[headers[i]] = value;
      });
      return obj;
    });

    const csv = Papa.unparse(dataForExport, { header: true });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `approved_customers_${moment().format('YYYY-MM-DD_HHmmss')}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    logicContext.showToast('✅ CSV exported successfully!', 'success');
  };
  // =======================================================

  return (
    <>
      <section className="@container">
        <section className="mt-2 w-full bg-white">
          {/* Top Actions: Toolbar */}
          <div className="flex flex-col gap-4 @xl:flex-row @xl:items-end @xl:justify-between">
            {/* Left side: Refresh & Filters */}
            <div className="flex w-full flex-col gap-3 @2xl:w-auto lg:flex-row lg:items-center">
              <div className="flex items-center gap-3">
                <Tooltip title="Reload">
                  <button
                    type="button"
                    onClick={getApprovedList}
                    className="shrink-0 rounded-xl border border-gray-200 p-2.5 text-gray-500 transition-all hover:border-blue-200 hover:bg-gray-50 hover:text-blue-600 active:scale-95"
                  >
                    <IoMdRefresh className="h-5 w-5" />
                  </button>
                </Tooltip>

                <Tooltip title="Total">
                  <div className="flex items-center whitespace-nowrap rounded-lg border border-blue-100 bg-blue-50/50 px-4 py-2.5 text-sm font-semibold text-blue-700 shadow-sm transition-colors hover:bg-blue-50">
                    <span className="mr-1">Total:</span>
                    <span>{tableList?.length}</span>
                  </div>
                </Tooltip>
              </div>

              <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row">
                <div className="w-full flex-1 sm:w-auto sm:min-w-[180px]">
                  <ApproveFilterSelect approve_status={getRecoilList.approve_status} onStatusFilterSelect={onStatusFilterSelect} />
                </div>
                <div className="w-full flex-1 sm:w-auto sm:min-w-[180px]">
                  <CopFilterList copList={getRecoilList.corporate_ddl} onCopFilterSelect={onCopFilterSelect} />
                </div>
              </div>
            </div>

            {/* Right side: Actions */}
            <div className="flex w-full items-center gap-3 @xl:w-auto">
              <button
                onClick={exportToCSV}
                className="flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-gray-200 bg-white px-4 py-2.5 font-[Poppins] text-xs font-semibold text-gray-700 transition-all @xl:py-2.5 hover:border-gray-300 hover:bg-gray-50 active:bg-gray-100 sm:flex-none"
              >
                <IoCloudDownloadOutline className="h-[18px] w-[18px] shrink-0 text-gray-500" />
                EXPORT CSV
              </button>
            </div>
          </div>

          <section className="mt-6">
            <div className="mb-4 flex flex-col justify-between gap-4 sm:items-center md:flex-row">
              {/* Table Search */}
              <div className="relative w-full sm:w-[350px]">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <IoSearch className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Search in table..."
                  value={searchText}
                  onChange={e => handleSearch(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Escape') {
                      onClearInput();
                    }
                  }}
                  className="w-full rounded-xl border border-gray-200 bg-gray-50 py-2.5 pl-10 pr-10 text-sm text-gray-700 placeholder-gray-400 outline-none transition-all focus:border-blue-500 focus:bg-white focus:ring-2 focus:ring-blue-100"
                />
                {searchText && (
                  <button
                    onClick={onClearInput}
                    className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-gray-600"
                  >
                    <IoClose className="h-5 w-5" />
                  </button>
                )}
              </div>
            </div>

            <GeneralCustomTable
              tableHeadList={columns}
              tableDataList={tableList}
              allowCheckBox={false}
              paginationOptions={paginationOptions}
              rowKey={record => record.Customer_Id}
              handleRowClick={handleRowClick}
            />
          </section>
        </section>
      </section>
    </>
  );
}

export default CustomerApprovalPage;
